import React, { Component } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Viewer from '../forge/Viewer';
import Projects from '../Data/sampleprojectdata.json';
import Workorders from '../components/workorders';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import { hideModel, hideItemByName } from '../forge/Viewer-helpers';

import Timeline from 'react-calendar-timeline'
// make sure you include the timeline stylesheet or the timeline will not be styled
import 'react-calendar-timeline/lib/Timeline.css'
import moment from 'moment'

// test 2
import { Gantt, Task, EventOption, StylingOption, ViewMode, DisplayOption } from 'gantt-task-react';
import "gantt-task-react/dist/index.css";


const projectDetails = Projects.find(project => project.name === localStorage.getItem('projectName'))
const workOrderDetails = projectDetails && projectDetails.history


// const groups = [
//   { id: 1, title: 'Wo980111' }, 
//   { id: 2, title: 'Wo978358'}, 
//   { id: 3, title: 'Wo985223'}
// ]


// const items = [
//   {
//     id: 1,
//     group: 1,
//     title: 'Breaker Replacement',    
//     start_time: moment(),
//     end_time: moment().add(25, 'hour')
//   },
//   {
//     id: 2,
//     group: 2,
//     title: 'Conduit Pull',    
//     start_time: moment().add(-0.5, 'hour'),
//     end_time: moment().add(4, 'hour')
//   },
//   {
//     id: 3,
//     group: 3,
//     title: 'Relay reset',  
//     start_time: moment().add(2, 'hour'),
//     end_time: moment().add(18, 'hour')
//   }
// ]

const currentDate = new Date();

const tasks = [
  {
    start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 15),
    name: "Lamar  Station Schedule",
    id: "LamarStationSchedule",
    progress: 100,
    type: "project",
    hideChildren: false,
    displayOrder: 1,
    forgeItems: ["DigitalTwinDemo.iam"]
  },
  {
    start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    end: new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      2,
      12,
      28
    ),
    name: "Outage #1- 21-157428",
    id: "Outage #1-21-157428",
    progress: 100,
    type: "task",
    project: "LamarStationSchedule",
    displayOrder: 2,
    forgeItems: ["Transformer_138kV.iam:1"]
  },
  {
    start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 2),
    end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 8, 0, 0),
    name: "Disconnect 138 kV CAP Bank Switches",
    id: "Disconnect138kVCAPBankSwitches",
    progress: 100,
    dependencies: [],
    type: "task",
    project: "LamarStationSchedule",
    displayOrder: 2.1,
    forgeItems: ["Cap_Bank_Breaker_138kV.iam:1"]
  },
  {
    start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 4),
    end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 8, 0, 0),
    name: "Pre-Spring Outage Scope",
    id: "Pre-SpringOutageScope",
    progress: 62,
    dependencies: [],
    type: "task",
    project: "LamarStationSchedule",
    displayOrder: 3,
    forgeItems: ["Cap_Bank_Breaker_138kV.iam:1"]
  },
  {
    start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 8),
    end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 6, 0, 0),
    name: "1385 kV CAP Bank Demo",
    id: "138kVCAPBankDemo",
    progress: 10,
    dependencies: ["Pre-SpringOutageScope"],
    type: "task",
    project: "LamarStationSchedule",
    displayOrder: 3.1,
    forgeItems: ["Cap_Bank_Breaker_138kV.iam:1"]
  },
  {
    start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 8),
    end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 10),
    name: "Demo Circuit Breaker",
    id: "DemoCircuitBreakere",
    type: "task",
    progress: 70,
    dependencies: ["69kVCAPBankDemo"],
    project: "LamarStationSchedule",
    displayOrder: 3.2,
    forgeItems: ["Circuit_Breaker_138kV.iam:1"]
  },
  {
    start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 15),
    end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 15),
    name: "Demo CAP Bank Foundation",
    id: "DemoCAPBankFoundation",
    progress: currentDate.getMonth(),
    type: "task",
    dependencies: ["DemoCircuitBreakere"],
    project: "LamarStationSchedule",
    displayOrder: 3.3,
    forgeItems: ["138KV Foundation -K.ipt:1"]
  },
  {
    start: new Date(currentDate.getFullYear(), currentDate.getMonth(), 18),
    end: new Date(currentDate.getFullYear(), currentDate.getMonth(), 19),
    name: "Live",
    id: "Live",
    progress: 0,
    isDisabled: true,
    type: "milestone",
    forgeItems: ["DigitalTwinDemo.iam"]
  },
];


var items = []
var groups = []

class ConstructionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }



  handleChange = name => event => {
    //if (name == "question1") 
    //event.target.value
  }


  componentWillMount() {

    for (var i = 0; i < workOrderDetails.length; i++) {
      groups = [...groups, { id: i, title: workOrderDetails[i].workOrder }]
      items = [...items, {
        id: i,
        group: i,
        title: workOrderDetails[i].description,
        start_time: new Date(workOrderDetails[i].start_time),
        end_time: new Date(workOrderDetails[i].end_time),
      }]
    }
  }

  getTaskInfo(task) {
    // This funtion will take a task and set the visible
    // items
    hideItemByName(task.forgeItems)

  };

  handleExpanderClick = (task) => {

  };

 sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay))

  runAllTasks = async () => {
    hideItemByName(["Transformer_138kV.iam:1"])
    await this.sleep(2000);
    hideItemByName(["Circuit_Breaker_138kV.iam:1"])
    await this.sleep(2000);
    hideItemByName(["138KV Foundation -K.ipt:1"])
    await this.sleep(2000);
    hideItemByName(["DigitalTwinDemo.iam"])
  }

  render() {
    return (
      <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>

          {/* Chart */}
          <Grid item xs={12} md={12} lg={12}>

            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 600,
              }}
            >
              <Viewer
                // key={Math.random()}
                viewerDiv={'forgeViewer'}
                urn={projectDetails.modelUrn}
                showSensors={false}
                extensions={['IssuesExtension', 'HeatmapExtension', 'Autodesk.Viewing.MarkupsGui']}
                hasDwg={1}
              />
            </Paper>
          </Grid>
       
          <Grid item xs={12}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" gutterBottom component="div">
                Work Order View
              </Typography>
              <Timeline
                groups={groups}
                items={items}
                defaultTimeStart={moment().add(-12, 'hour')}
                defaultTimeEnd={moment().add(12, 'hour')}
              />

            </Paper>
          </Grid>

          <Grid item xs={6} md={6} lg={6}>
            <Paper
              sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                height: 530,
              }}
            >
              <Workorders />

            </Paper>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <Button variant="contained" onClick={this.runAllTasks} >Play All Tasks</Button>
            </Paper>
          </Grid>
          {/* Recent Orders */}
          <Grid item xs={6}  md={6} lg={6}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <Typography variant="h6" gutterBottom component="div">
                WO87312 Schedule
              </Typography>
              <Gantt
                onExpanderClick={this.handleExpanderClick}
                tasks={tasks}
                onDoubleClick={this.getTaskInfo}
              />
            </Paper>

          </Grid>

          

        </Grid>

      </Container>
    )
  }
}

export default ConstructionView;